/* eslint-disable no-nested-ternary */
/* eslint-disable no-alert */
import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import NewPublicTabs from "../../../../common/tabBar/NewPublicTabs";
import { TABSBox } from "../static/tabsData";
import OrganizationInfo from "./organizationInfo/OrganizationInfo";
import OrganizationGallery from "./organizationGallery/OrganizationGallery";
import OrganizationContact from "./organizationContact/OrganizationContact";
import { getApiService } from "../../../../../services/AgapeAPI";
import OrganizationDocuments from "./organizationDocuments/OrganizationDocuments";
import OrganizationUserComments from "./organizationUserComments/OrganizationUserComments";
import TabsLoading from "../static/TabsLoading";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 20,
  },
  customTabs: {
    maxWidth: "100%",
    width: "100%",
    "& .MuiTabs-flexContainer": {
      justifyContent: "flex-start",
    },
  },
}));

export default function TabsSelection({ data, getData }) {
  const classes = useStyles();

  const [tab, setTab] = React.useState(0);
  const [loading, setLoading] = React.useState(false);

  const [docs, setDocs] = React.useState({});
  const [contact, setContact] = React.useState({});

  React.useEffect(() => {
    switch (tab) {
      case 1:
        setLoading(true);
        getApiService(`pub/organizations/${data.code}/docs`).then((res) => {
          setDocs(res.data.data);
          setLoading(false);
        });
        break;
      case 2:
        setLoading(true);
        getApiService(`pub/organizations/${data.code}/contacts`).then((res) => {
          setContact(res.data.data);
          setLoading(false);
        });
        break;

      default:
        setLoading(false);
        break;
    }
  }, [tab]);

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  const components = [
    <OrganizationInfo code={data.code} />,
    <OrganizationDocuments data={docs} />,
    <OrganizationContact data={contact} />,
    <OrganizationGallery code={data.code} />,
    <OrganizationUserComments
      code={data.code}
      userRate={data.user_rate}
      getData={getData}
    />,
  ];

  return (
    <div className={classes.root}>
      <NewPublicTabs
        data={TABSBox}
        tab={tab}
        setTab={setTab}
        handleTabChange={handleChange}
        customClassName={classes.customTabs}
      />
      <div>{loading ? <TabsLoading /> : components[tab]}</div>
    </div>
  );
}
